import Crud from '../views/TipoVeiculo/Crud'
import Entity from '../views/TipoVeiculo/Add'

let routes = {
    path: '/tipo_veiculos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_veiculos/add',
            name: 'NewTipoVeiculo',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Veículo',
                breadcrumb: [
                    {
                        text: 'Tipos de Veículo',
                        to: '/tipo_veiculos',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_veiculos/edit/:id?',
            name: 'EditTipoVeiculo',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Veículo',
                breadcrumb: [
                    {
                        text: 'Tipos de Veículo',
                        to: '/tipo_veiculos',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/tipo_veiculos',
            name: 'list-tipo_veiculos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipo de Veículo',
                breadcrumb: [
                    {
                        text: 'Tipos de Veículo',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
